import { StarGlyph } from "@/components/Wordmark";

const ITEMS = [
    "BEHAVIOR FIRST",
    "ASTROLOGY SECOND",
    "RECOGNITION BEFORE EXPLANATION",
    "NOT A HOROSCOPE",
    "NO GENERIC PERSONALITY TEST BULLSHIT",
];

function Row({ hidden = false }) {
    return (
        <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
            {ITEMS.map((t, i) => (
                <span key={i} className="flex items-center">
                    <span className="whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.3em] text-slate-400">
                        {t}
                    </span>
                    <StarGlyph className="mx-7 h-3 w-3 shrink-0 text-celestial-gold/70" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div
            data-testid="marquee"
            className="relative overflow-hidden border-y border-white/10 py-4"
        >
            <div className="marquee-track flex w-max">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
